// TODO: delete this file
export class BEHError extends Error {
  type: string;
  status: string | undefined;
  detail: string;
  traceId: string | undefined;
  title: string;
  violations: Array<any>;

  constructor(
    type: string,
    msg: string,
    status: string | undefined,
    detail: string,
    traceId: string | undefined,
    title: string,
    violations: Array<any>
  ) {
    super(msg);
    this.type = type;
    this.status = status;
    this.detail = detail;
    this.traceId = traceId;
    this.title = title;
    this.violations = violations;
  }
}

const errorMsgBackend =
  'Bitte wenden Sie sich mit folgendem Error-Code an Ihren Administrator.';

export const fjdAlertErrorBackendMsg = 'Es ist ein Fehler aufgetreten. '.concat(
  errorMsgBackend
);
